<template>
  <div class="topMenu-container">
    <el-menu mode="horizontal" @select="handleSelect" :default-active="activeIndex">
      <menutree v-for="item in menuList" :key="item.url" :menu="item"></menutree>
    </el-menu>
  </div>
</template>
<script>
import menutree from "@/components/MenuTree";
export default {
  components: { menutree },
  props: {},
  data() {
    var ds = {};
    ds.activeIndex = "";
    ds.menuList = [];
    return ds;
  },
  mounted() {
    this.uiLoadMenu();
    this.$bus.$on("setActiveIndex", (activeIndex) => {
      this.activeIndex = activeIndex;
    });

  },
  watch: {},
  methods: {
    /**
     * 加载菜单
     */
    uiLoadMenu() {
      let menus = this.$permission.GetTopMenus();
      if (menus) {
        this.menuList = menus;
      } else {
        this.menuList = [];
      }
    },
     handleSelect(key, keyPath) {
    //   this.$emit("toggleChange");
      this.$bus.$emit("setLeftActiveIndex",key)
    },
  },
};
</script>
<style scoped>
.el-menu {
  background-color: transparent;
}
.el-menu.el-menu--horizontal {
  border: none;
}
.el-menu--horizontal > .el-menu-item {
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  color: #dde6fd !important;
  border-bottom: none !important;
}
/deep/.el-menu--horizontal > .el-submenu .el-submenu__title {
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  color: #dde6fd;
  border-bottom: none;
}
/deep/.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  font-size: 18px;
  color: #dde6fd;
}
/deep/.topMenu-container .el-submenu__title i {
  font-size: 24px;
  color: #dde6fd;
}
/deep/.topMenu-container .el-menu-item i {
  font-size: 24px;
  color: #dde6fd;
}
/deep/.topMenu-container .el-submenu .el-menu-item i {
  color: #a29faa;
}
/deep/.topMenu-container .el-submenu .el-menu-item:hover {
  color: #091d7c !important;
}
/deep/.topMenu-container .el-submenu .el-menu-item:hover > i {
  color: #091d7c;
}
/deep/.topMenu-container
  .el-menu--horizontal
  .el-menu
  .el-menu-item.is-active
  > i {
  color: #091d7c;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  /*background-color: transparent !important;*/
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover > i {
  color: white;
}
/deep/.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
}
/deep/.el-menu--horizontal > .el-submenu .el-submenu__title:hover > i {
  color: white;
}
/deep/.el-submenu .el-menu-item {
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: #a29faa;
}
/deep/.el-menu--horizontal .el-menu .el-menu-item.is-active,
.el-menu--horizontal .el-menu .el-submenu.is-active > .el-submenu__title {
  color: #091d7c;
}

/deep/.topMenu-container
  .el-menu--horizontal
  > .el-submenu.is-active
  .el-submenu__title {
  border-bottom: none !important;
  color: white !important;
}
/deep/.topMenu-container
  .el-menu--horizontal
  > .el-submenu.is-active
  .el-submenu__title
  > i {
  color: white !important;
}
/deep/.topMenu-container
  .el-menu--horizontal
  > .el-submenu:hover
  > .el-submenu__title {
  border-bottom: none !important;
  color: white !important;
}
/deep/.topMenu-container
  .el-menu--horizontal
  > .el-submenu.hover
  > .el-submenu__title
  > i {
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/TopMenu.vue